import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// import { AppModule } from './presentation/app.module';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './presentation/app.component';
import { appConfig } from './presentation/config';

loadEnvConfig().then(() => {
    const env = (window as any).__env;

    if (env?.environmentDeployment === 'PROD') {
        enableProdMode();
    }

    // platformBrowserDynamic()
    //     .bootstrapModule(AppModule)
    //     .catch((err) => console.error(err));

    bootstrapApplication(AppComponent, appConfig).catch((err) =>
        console.error(err)
    );
});

function loadEnvConfig(): Promise<void> {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'assets/config/env.js'; // ✅ nom correct
        script.onload = () => resolve();
        script.onerror = () => reject(`❌ Could not load env.js`);
        document.head.appendChild(script);
    });
}
